import React, { useState, useEffect } from "react";

import CountryInput from "./CountryInput";
import StateInput from "./StateInput";
import checkMemberEmail from "../helpers/check-member-email";

// MemberInfoForm component; displays the form to gather member information
const MemberInfoForm = (props) => {
    const {authenticationToken, config, cartTotal, selectedMembership, recipientDesignation, memberInfoFormObject, setMemberInfoFormObject, deliveryOption, setDeliveryOption, activeScreen, setActiveScreen, intent} = props;

    const [formHasErrors, setFormHasErrors] = useState(false);
    const [membershipExists, setMembershipExists] = useState(false);
    const [checkingMembershipExists, setCheckingMembershipExists] = useState(false);

    function handleChange(e) {
        setMemberInfoFormObject({...memberInfoFormObject, [e.target.dataset.person]: {...memberInfoFormObject[e.target.dataset.person], [e.target.dataset.key]: e.target.value}});

        if (formHasErrors) {
            validateForm();
        }
    }

    function validateForm() {
        setFormHasErrors(false);
        let errorFlag = false;
        document.querySelectorAll('.member-info-form input').forEach(field => {
            if (field.value.search(field.dataset.pattern) === -1) {
                errorFlag = true;
                field.classList.add('error');
            } else {
                field.classList.remove('error');
            }
        });

        document.querySelectorAll('.member-info-form select').forEach(field => {
            if (field.value == 'false') {
                errorFlag = true;
                field.classList.add('error');
            } else {
                field.classList.remove('error');
            }
        });

        if(membershipExists) {
            errorFlag = true;
            document.querySelector('#email').classList.add('error');
        }

        setFormHasErrors(errorFlag);

        if (!errorFlag) {
            submitForm();
        }
    }

    function submitForm() {
        if (!formHasErrors) {
            setActiveScreen('donation');
            window.scrollTo(0, 200);
        }
    }

    // reset delivery option if going back
    useEffect(() => {
        if (activeScreen == 'levels') {
            setDeliveryOption('mail');
        }
    }, [activeScreen]);

    useEffect(() => {
        // Only check for existing membership when purchasing a new membership
        if (intent === 'Purchase') {
            (async () => {
                setCheckingMembershipExists(true);

                const result = await checkMemberEmail(memberInfoFormObject?.primary?.email, config, authenticationToken);

                setCheckingMembershipExists(false);
                setMembershipExists(!!(result?.exists && result?.canRenew));
            })();
        } else {
            // For renewals, upgrades, etc., don't check - user is already authenticated
            setMembershipExists(false);
            setCheckingMembershipExists(false);
        }
    }, [memberInfoFormObject?.primary?.email, intent])

    return (
        <>
            <form className="member-info-form">

                {recipientDesignation == 'gift' && <>
                    <h5>Gift Giver Information</h5>
                    <fieldset>
                        <div class="form-columns">
                            <div className="fieldgroup">
                                <label htmlFor="giver-first-name">First name</label>
                                <input type="text" id="giver-first-name" data-pattern="\w{2,}" value={memberInfoFormObject.giver.firstName} data-person="giver" data-key="firstName" onChange={(e) => handleChange(e)}/>
                            </div>
                            <div className="fieldgroup">
                                <label htmlFor="giver-last-name">Last name</label>
                                <input type="text" id="giver-last-name" data-pattern="\w{2,}" value={memberInfoFormObject.giver.lastName} data-person="giver" data-key="lastName" onChange={(e) => handleChange(e)}/>
                            </div>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="giver-email">Email address</label>
                            <input type="email" id="giver-email" data-pattern="^[\w+.-]+@[\w.]+$" value={memberInfoFormObject.giver.email} data-person="giver" data-key="email" onChange={(e) => handleChange(e)}/>
                        </div>
                    </fieldset>
                </>}

                {recipientDesignation == 'certificate' && <>
                    <h2>Mailing Information</h2>
                    <p>A digital certificate will be emailed to you. This can be used by the recipient to redeem the membership. Would you also like a gift certificate to be mailed? If yes, please include the desired mailing address below. Please allow 1-2 business days for processing before the gift certificate is mailed.</p>
                    <div className="fieldgroup fieldgroup--checkbox">
                        <input
                            type="checkbox"
                            id="mail-certificate"
                            name="mail-certificate"
                            onClick={() => setDeliveryOption('mail')}
                            checked={deliveryOption == 'mail'}
                        />
                        <label htmlFor="mail-certificate">Yes, please mail a gift certificate to the address below.</label>
                    </div>
                    <div className="fieldgroup fieldgroup--checkbox">
                        <input
                            type="checkbox"
                            id="email-certificate"
                            name="email-certificate"
                            onClick={() => setDeliveryOption('email')}
                            checked={deliveryOption == 'email'}
                        />
                        <label htmlFor="email-certificate">No, I will use the email.</label>
                    </div>
                </>}
                {recipientDesignation != 'certificate' && <>
                    <h5>Primary Adult Member</h5>
                </>}
                {deliveryOption == 'mail' && <>
                    <fieldset>
                        <div class="form-columns">
                            <div className="fieldgroup">
                                <label htmlFor="first-name">First name</label>
                                <input type="text" id="first-name" data-pattern="\w{2,}" value={memberInfoFormObject.primary.firstName} data-person="primary" data-key="firstName" onChange={(e) => handleChange(e)}/>
                            </div>
                            <div className="fieldgroup">
                                <label htmlFor="last-name">Last name</label>
                                <input type="text" id="last-name" data-pattern="\w{2,}" value={memberInfoFormObject.primary.lastName} data-person="primary" data-key="lastName" onChange={(e) => handleChange(e)}/>
                            </div>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="email">Email address</label>
                            <input type="email" id="email" data-pattern="^[^@]+@[^@]+\.[^@\.]{2,}$" value={memberInfoFormObject.primary.email} data-person="primary" data-key="email" onChange={(e) => handleChange(e)}/>
                            {membershipExists && <>
                                <span className="error">A membership with this email already exists.</span>
                                <button
                                    type="button"
                                    className="button button--small membership__become-a-member"
                                    onClick={() => {
                                        setActiveScreen('login');
                                    }}
                                >
                                    Sign in
                                </button>
                            </>}
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="phone">Phone number</label>
                            <input type="tel" id="phone" data-pattern="^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$" value={memberInfoFormObject.primary.phoneNumber} data-person="primary" data-key="phoneNumber" onChange={(e) => handleChange(e)}/>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="country">Country</label>
                            {/* <input type="text" id="country" data-pattern="\w{2,}" value={memberInfoFormObject.primary.country} data-person="primary" data-key="country" onChange={(e) => handleChange(e)}/> */}
                            <CountryInput id="country" value={memberInfoFormObject.primary.country} data-person="primary" data-key="country" onChange={(e) => handleChange(e)} />
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="street-address">Street address</label>
                            <input type="text" id="street-address" data-pattern=".{2,}" value={memberInfoFormObject.primary.address1} data-person="primary" data-key="address1" onChange={(e) => handleChange(e)}/>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="street-address-2">Street address 2 (optional)</label>
                            <input type="text" id="street-address-2" value={memberInfoFormObject.primary.address2} data-person="primary" data-key="address2" onChange={(e) => handleChange(e)}/>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="city">City</label>
                            <input type="text" id="city" data-pattern="\w{2,}" value={memberInfoFormObject.primary.city} data-person="primary" data-key="city" onChange={(e) => handleChange(e)}/>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="state">State/Province</label>
                            <StateInput id="state" value={memberInfoFormObject.primary.state} country={memberInfoFormObject.primary.country} data-person="primary" data-key="state" onChange={(e) => handleChange(e)}/>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="zip">ZIP/Postal code</label>
                            <input type="text" id="zip" data-pattern=".{5,}" value={memberInfoFormObject.primary.zipCode} data-person="primary" data-key="zipCode" onChange={(e) => handleChange(e)}/>
                        </div>
                    </fieldset>
                </>}

                {/* special note */}
                {recipientDesignation == 'certificate' && deliveryOption == 'mail' && <>
                    <fieldset>
                        <div className="fieldgroup">
                            <label htmlFor="note">Special note to include or additional information</label>
                            <textarea id="note" value={memberInfoFormObject.giver.note} data-person="giver" data-key="note" onChange={(e) => handleChange(e)}/>
                        </div>
                    </fieldset>
                </>}

                {/* secondary adult member if applicable */}
                {selectedMembership.rules.numberOfCardHolders > 1 && recipientDesignation != 'certificate' && <>
                    <h5>Second Adult Member</h5>
                    <fieldset class="form-columns">
                        <div className="fieldgroup">
                            <label htmlFor="secondary-first-name">First name</label>
                            <input type="text" id="secondary-first-name" data-pattern="\w{2,}" value={memberInfoFormObject.secondary.firstName} data-person="secondary" data-key="firstName" onChange={(e) => handleChange(e)}/>
                        </div>
                        <div className="fieldgroup">
                            <label htmlFor="secondary-last-name">Last name</label>
                            <input type="text" id="secondary-last-name" data-pattern="\w{2,}" value={memberInfoFormObject.secondary.lastName} data-person="secondary" data-key="lastName" onChange={(e) => handleChange(e)}/>
                        </div>
                    </fieldset>
                </>}

            </form>                
            <hr/>
            <div className="membership__total">
                <span className="membership__total-title">
                    Total
                </span>
                <span className="membership__total-amount">
                    ${cartTotal}
                </span>
            </div>
            {formHasErrors && <p className="member-info-form__error-text"><i className="fa fa-warning"></i>Please correct missing or incorrect information.</p>}
            <button
                className="button button--stretch"
                disabled={formHasErrors || checkingMembershipExists}
                onClick={() => validateForm()}
            >
                Continue
            </button>
        </>
    );
}

export default MemberInfoForm;